var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93079 19.1374C3.99845 19.1374 0 14.8533 0 9.5687C0 4.28405 3.99845 0 8.93079 0C13.8631 0 17.8616 4.28405 17.8616 9.5687C17.8616 11.78 17.1615 13.816 15.9859 15.4364L22 21.88L20.4212 23.5715L14.4071 17.1279C12.8948 18.3874 10.9946 19.1374 8.93079 19.1374ZM15.6289 9.5687C15.6289 13.5322 12.6301 16.7452 8.93083 16.7452C5.23157 16.7452 2.23274 13.5322 2.23274 9.5687C2.23274 5.60521 5.23157 2.39217 8.93083 2.39217C12.6301 2.39217 15.6289 5.60521 15.6289 9.5687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2f585cc4f5c653302c0a68ab18d093d4.svg";
export { ForwardRef as ReactComponent };